const yesNoModel = () => {
    return {
        yesNo : [
            {
                id: true,
                option: 'Yes',
            },
            {
                id: false,
                option: 'No'
            }
        ]
    };
};

export default yesNoModel;
